var _circle, _circle2, _circle3, _path, _path2, _circle4, _rect, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 115,
    viewBox: "0 0 153 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.4037,
    cy: 62,
    r: 47,
    fill: "#E1EBFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.4037,
    cy: 62,
    r: 53,
    fill: "#E1EBFF",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.4037,
    cy: 62,
    r: 41,
    fill: "#1570EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.441 29.0769V25.4229H121.877V23.8389H125.441V20.2929H127.097V23.8389H130.661V25.4229H127.097V29.0769H125.441Z",
    fill: "#18305D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74683 48.2087L7.14776 44.6042L3.63199 45.1885L3.3723 43.6259L6.88807 43.0416L6.30672 39.5436L7.94031 39.2721L8.52167 42.7701L12.0374 42.1858L12.2971 43.7484L8.78136 44.3327L9.38042 47.9372L7.74683 48.2087Z",
    fill: "#18305D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.8024,
    cy: 4.7191,
    r: 3.9691,
    stroke: "#18305D",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.2787,
    y: 99.1016,
    width: 5.89888,
    height: 5.89888,
    fill: "#18305D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.338 86.123L145.243 93.4763L152.596 94.3815L145.243 95.2866L144.338 102.64L143.433 95.2866L136.079 94.3815L143.433 93.4763L144.338 86.123Z",
    fill: "#18305D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.069 49.5L71.1524 72.4167L60.7357 62",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e89a8bb8a07fe5fad5d595ce24cba77b.svg";
export { ForwardRef as ReactComponent };